import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.modalOverlay};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 999;
  overflow: hidden;
`;


const ModalContent = styled.div`
  background: ${(props) => props.theme.sidebarBackground};
  width: ${({ width }) => width || "600px"};
  height: ${({ minH }) => minH || "80vh"};
  max-height: 90vh;
  border-radius: 10px;
  overflow: hidden; 
  position: relative;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
`;


const ModalHeader = styled.div`
  background-color: ${(props) => props.theme.modalHeader};
  color: white;
  padding: 16px;
  font-size: var(--app-font-size);
  font-weight: bold;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalChildren = styled.div`
  flex: 1;
  overflow: hidden; 
  display: flex;
`;


const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
`;

const ModalPDF = ({
  isOpen,
  onClose,
  title,
  children,
  width,
  minH,
  closeOnOverlay = false,
  closeOnEsc = true,
}) => {
  React.useEffect(() => {
    if (!isOpen || !closeOnEsc || typeof onClose !== "function") return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, closeOnEsc, onClose]);

  if (!isOpen) return null;

  return (
    <Overlay onClick={closeOnOverlay ? onClose : undefined}>
      <ModalContent onClick={(e) => e.stopPropagation()} width={width} minH={minH} >
        <ModalHeader>
          {title}
          <CloseButton onClick={onClose} className="hover">&times;</CloseButton>
        </ModalHeader>
        <ModalChildren>
          {children}
        </ModalChildren>
      </ModalContent>
    </Overlay>
  );
};

export default ModalPDF;
